var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": _vm.newDepartment ? '新增' : '编辑' + '部门'
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_vm.selectedParentDepartment ? _c('span', [_vm._v(_vm._s(_vm.openedDepartment.name) + "将添加在 " + _vm._s(_vm.selectedParentDepartment.name || "全部") + " 下")]) : _c('span', [_vm._v("请选择新部门将要添加的位置")]), _c('div', {
    staticClass: "tree-wrapper"
  }, [_c('Tree', {
    attrs: {
      "data": _vm.treeDepartmentData,
      "render": _vm.renderContent
    }
  })], 1), _c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "部门名字",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入名字..."
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('CheckboxGroup', {
    model: {
      value: _vm.formItem.type,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "type", $$v);
      },
      expression: "formItem.type"
    }
  }, [_c('Checkbox', {
    attrs: {
      "label": "sales"
    }
  }, [_vm._v("销售")]), _c('Checkbox', {
    attrs: {
      "label": "tech"
    }
  }, [_vm._v("技术")])], 1)], 1), _c('FormItem', {
    attrs: {
      "label": "是否禁用"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large",
      "true-color": "#ff4949"
    },
    model: {
      value: _vm.formItem.banned,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "banned", $$v);
      },
      expression: "formItem.banned"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }